/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiScenarioComputedParameter
 */
export interface InternalApiScenarioComputedParameter {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioComputedParameter
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioComputedParameter
     */
    displayName?: string;
}

/**
 * Check if a given object implements the InternalApiScenarioComputedParameter interface.
 */
export function instanceOfInternalApiScenarioComputedParameter(value: object): value is InternalApiScenarioComputedParameter {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function InternalApiScenarioComputedParameterFromJSON(json: any): InternalApiScenarioComputedParameter {
    return InternalApiScenarioComputedParameterFromJSONTyped(json, false);
}

export function InternalApiScenarioComputedParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioComputedParameter {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
    };
}

export function InternalApiScenarioComputedParameterToJSON(json: any): InternalApiScenarioComputedParameter {
    return InternalApiScenarioComputedParameterToJSONTyped(json, false);
}

export function InternalApiScenarioComputedParameterToJSONTyped(value?: InternalApiScenarioComputedParameter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'displayName': value['displayName'],
    };
}

